export const userExceptions = {
  fetchAllUsers: "Error al obtener a los usuarios",
  fetchUserByID: "Error al obtener el usuario por un determinado id",
  updateUser: "Error al actualizar el usuario",
};
